import { ICustomerUser } from './customer.dto';

export type WeightLogSource = 'questionnaire' | 'customer_manual_entry';

export class WeightLog {
  _id?: string;
  customer: string | ICustomerUser;
  weight: number;
  loggedAt: Date;
  createdAt?: Date;
  updatedAt?: Date;
  organization?: string;
  source?: WeightLogSource;
  notes?: string;
}

export interface WeightLogQueryParams {
  id?: string;
  customer?: string | ICustomerUser;
  minLoggedDate?: string;
  maxLoggedDate?: string;
  limit?: number;
  offset?: number;
  sortField?: string;
  sortOrder?: number;
}

export class IWeightLog extends WeightLog {}
